






















































































































import { Routes } from "../../utils/Routes";
import { AvisDeVirementLigne } from "../../models/AvisDeVirementLigne";

export default {
    name: "AvisDeVirementLignes",
    props: {
        lignes: {
            type: Array,
            default: () => [],
        },
        montantAvis: Number,
        // Active le double-clic d'édition (liste uniquement, pas la modale).
        editable: Boolean,
        // L'avis entier a été rapproché (ou marqué effectué manuellement) :
        // toutes ses lignes sont réglées, sans lien ligne à ligne.
        avisEffectue: Boolean,
    },
    computed: {
        hasVirements(): boolean {
            return _.some(this.lignes, "numero_virement");
        },
        hasOperations(): boolean {
            return _.some(this.lignes, "operation_bancaire_id");
        },
        colspanTotal(): number {
            return 5 + (this.hasVirements ? 1 : 0) + (this.hasOperations ? 1 : 0);
        },
        total(): number {
            return _.round(
                _.sumBy(this.lignes, (ligne) => ligne.montant || 0),
                2
            );
        },
        montantDiverge(): boolean {
            return (
                this.montantAvis != null &&
                Math.abs(this.total - this.montantAvis) > 0.01
            );
        },
    },
    methods: {
        addCoproprieteUrl(ligne: AvisDeVirementLigne): string {
            if (ligne.copropriete_name) {
                return Routes.new_contact + "?nom=" + ligne.copropriete_name;
            }
        },
        isRapprochee(ligne: AvisDeVirementLigne): boolean {
            return !!ligne.operation_bancaire_id || this.avisEffectue;
        },
        roundAmount(amount) {
            return _.round(amount || 0, 2).toFixed(2);
        },
    },
};
